import { sendRequest } from "../../hooks/requests/useRequest";


export async function getAllThermometers ()
{
    const requestOptions = {
        method: 'GET'
    };

    const response = await sendRequest(requestOptions, `Thermometers/List`);

    if (response.code === 200)
        return response.data;
    else 
        return response;
}


export async function createThermometers(thermometer) {
    const body = JSON.stringify(thermometer);

    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body
    };

    const response = await sendRequest(requestOptions, "Thermometers");

    if (response.code === 200) {
        return response.data;
    } else {
        return response;
    }
}


export async function updateThermometers({id_thermometer, name_thermometer, abbreviation, internal_thermometer, correction_factor}) {
    const body = {
        id_thermometer,
        name_thermometer, 
        abbreviation,
        internal_thermometer,
        correction_factor, 
    };

    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(body)
    };

    const response = await sendRequest(
        requestOptions, "Thermometers/Update"
    );

    if (response.code === 200)
        return {
            code: response.code,
            data: response.data
        }
    else if (response.code === 401)
        return response.code;
    else
        return {
            code: response.code,
            msg: response?.data?.msg
        };
}


export async function deleteThermometers({ id_thermometer}) {
  
    const requestOptions = {
        method: 'DELETE',
    };

    const response = await sendRequest(
        requestOptions, `Thermometers/${id_thermometer}`
    );

    if (response.code === 200)
        return {
            code: response?.code ,
          
        }
    else if (response.code === 401)
        return response.code;
    else
        return {
           
            response: response?.code ,

        };
}
